import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Select, Store } from '@ngxs/store';
import { Observable, map } from 'rxjs';
import { PatientInsurance, PaymentMethod, ReorderDetails, ReorderDetailsItem } from 'src/app/core/models';
import { ResponsiveUtilsService } from 'src/app/core/services';
import { OrderWizardDataState } from 'src/app/core/store/order-wizard/order-wizard-data/order-wizard-data.state';
import {
  InsuranceUserData,
  OrderWizardStatus,
  ProductItemQuantityUserData,
  ProviderUserData,
  SelectedProvider,
} from 'src/app/core/store/order-wizard/order-wizard-data/order-wizard-data.model';
import { CcsSentryError } from 'src/app/core/store/utils';
import { OrderWizardNavigationState } from 'src/app/core/store/order-wizard/order-wizard-navigation/order-wizard-navigation.state';
import { WizardStep } from 'src/app/core/store/order-wizard/order-wizard-navigation/order-wizard-navigation.model';

@Component({
  selector: 'app-summary-step',
  templateUrl: './summary-step.component.html',
  styleUrls: ['./summary-step.component.scss'],
})
export class SummaryStepComponent {
  @Select(OrderWizardDataState.isSummaryStepLoading) isSummaryStepLoading$!: Observable<boolean>;
  @Select(OrderWizardDataState.summaryStepError) summaryStepError$!: Observable<CcsSentryError | null>;
  @Select(OrderWizardNavigationState.steps) steps$!: Observable<WizardStep[]>;
  @Select(OrderWizardDataState.reorder) reorder$!: Observable<ReorderDetails>;
  @Select(OrderWizardDataState.reorderItemsSummary) reorderItemsSummary$!: Observable<
    (ReorderDetailsItem & ProductItemQuantityUserData)[]
  >;
  @Select(OrderWizardDataState.insurance) insurance$!: Observable<PatientInsurance>;
  @Select(OrderWizardDataState.insuranceUserData) insuranceUserData$!: Observable<InsuranceUserData>;
  @Select(OrderWizardDataState.selectedProvider) selectedProvider$!: Observable<SelectedProvider>;
  @Select(OrderWizardDataState.providerUserData) providerUserData$!: Observable<ProviderUserData>;
  @Select(OrderWizardDataState.selectedPaymentMethod) selectedPaymentMethod$!: Observable<PaymentMethod | null>;
  @Select(OrderWizardDataState.skipBillingStep) skipBillingStep$!: Observable<OrderWizardStatus>;
  @Select(OrderWizardDataState.hideSummaryStepBillingInfo)
  hideSummaryStepBillingInfo$!: Observable<OrderWizardStatus>;

  isLgAndAbove$: Observable<boolean> = this.responsiveUtils.isLgAndAbove();
  insurancePendingVerification$ = this.insuranceUserData$.pipe(
    map(({ primaryInsurance, secondaryInsurance }) => primaryInsurance !== null || secondaryInsurance !== null)
  );
  providerPendingVerification$ = this.providerUserData$.pipe(
    map(({ newProviderFormValues }) => newProviderFormValues !== null)
  );

  constructor(
    private store: Store,
    private router: Router,
    private route: ActivatedRoute,
    public responsiveUtils: ResponsiveUtilsService
  ) {}

  navigateToBillingStep() {
    const steps = this.store.selectSnapshot(OrderWizardNavigationState.steps);

    this.router.navigate([steps.find((s) => s.key === 'billing')?.url], {
      relativeTo: this.route.parent,
    });
  }
}
